import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NavService, Menu } from '../../services/nav.service';
import { TranslateService } from '@ngx-translate/core';
import { CustomizerService } from '../../services/customizer.service';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../../auth/authentication.service';
import { CommonService } from '../../services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
var body = document.getElementsByTagName("body")[0];
import * as XLSX from 'xlsx';
import { ApiService } from '../../services/api.service';

const searchItems = [
    "policy",
    "policy number",
    "policy status",
    "policy startdate",
    "quote",
    "quote number",
    "quote startdate",
    "claim",
    "claim number",
    "claim status",
    "claim lossdate",
    "name",
    "client id",
    "client name",
    "client number",
    "client mobile"
];

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

    public menuItems: Menu[];
    public items: Menu[];
    public searchResult: boolean = false;
    public searchResultEmpty: boolean = false;
    public openNav: boolean = false
    public right_sidebar: boolean = false
    public text: string
    public isOpenMobile: boolean = false
    @Output() rightSidebarEvent = new EventEmitter<boolean>();
    searchItem: string;
    constructor(public navServices: NavService,
        private translate: TranslateService,
        public customize: CustomizerService,
        public router: Router,
        public authService: AuthenticationService,
        private route: ActivatedRoute,
        private commonService: CommonService,
        private modalService: NgbModal,
        private apiService: ApiService) {
        //translate.setDefaultLang('en');
    }

    search = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 2 ? []
                : this.filterSearch(term))
        );

    filterSearch(term: string) {
        var items = []; //searchItems.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1);
        if (term) {

            if (term.startsWith("client name") == true) {
                items.push("client name " + term.replace("client name", "").trim());
            }
            else if (term.startsWith("client number") == true) {
                items.push("client number " + term.replace("client number", "").trim());
            }
            else if (term.startsWith("client mobile") == true) {
                items.push("client mobile " + term.replace("client mobile", "").trim());
            }
            else if (term.startsWith("client id") == true) {
                items.push("client id " + term.replace("client id", "").trim());
            }
            else if (term.startsWith("policy startdate") == true) {
                items.push("policy startdate " + term.replace("policy startdate", "").trim());
            }
            else if (term.startsWith("policy status") == true) {
                items.push("policy status " + term.replace("policy status", "").trim());
            }
            else if (term.startsWith("policy number") == true) {
                items.push("policy number " + term.replace("policy number", "").trim());
            }
            else if (term.startsWith("policy") == true) {
                items.push("policy " + term.replace("policy", "").trim());
            }
            else if (term.startsWith("quote start") == true) {
                items.push("quote start " + term.replace("quote start", "").trim());
            }
            else if (term.startsWith("quote number") == true) {
                items.push("quote number " + term.replace("quote number", "").trim());
            }
            else if (term.startsWith("quote") == true) {
                items.push("quote " + term.replace("quote", "").trim());
            }
            else if (term.startsWith("name") == true) {
                items.push("name " + term.replace("name", "").trim());
            }
            else if (term.startsWith("claim lossdate") == true) {
                items.push("claim lossdate " + term.replace("claim lossdate", "").trim());
            }
            else if (term.startsWith("claim status") == true) {
                items.push("claim status " + term.replace("claim status", "").trim());
            }
            else if (term.startsWith("claim number") == true) {
                items.push("claim number " + term.replace("claim number", "").trim());
            }
            else if (term.startsWith("claim") == true) {
                items.push("claim " + term.replace("claim", "").trim());
            }
            else
                items = searchItems.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1);
        }
        return items;
    }
    onKeydown(event) {
        if (this.searchItem &&
            this.searchItem.toLowerCase().indexOf("policy") > -1 &&
            this.searchItem.toLowerCase().replace("policy", "").length > 2) {
            this.router.navigate(["App/Policy/Search"], { queryParams: { "externalCode": this.searchItem.substr(7), "quoteIndicator": "N" }, relativeTo: this.route });
        } else if (this.searchItem &&
            this.searchItem.toLowerCase().indexOf("quote") > -1 &&
            this.searchItem.toLowerCase().replace("quote", "").length > 2) {
            this.router.navigate(["App/Policy/Search"], { queryParams: { "externalCode": this.searchItem.substr(6), "quoteIndicator": "Y" }, relativeTo: this.route });
        }
        else if (this.searchItem &&
            this.searchItem.toLowerCase().indexOf("name") > -1 &&
            this.searchItem.toLowerCase().replace("name", "").length > 2) {
            this.router.navigate(["App/Client/Search"], { queryParams: { "clientName": this.searchItem.substr(5) }, relativeTo: this.route });
        }
        else if (this.searchItem &&
            this.searchItem.toLowerCase().indexOf("claim") > -1 &&
            this.searchItem.toLowerCase().replace("claim", "").length > 2) {
            this.router.navigate(["App/Claim/Search"], { queryParams: { "externalCode": this.searchItem.substr(6) }, relativeTo: this.route });
        }
    }

    selectedItem(event) {
        console.log(event);
    }

    ngOnDestroy() {
        this.removeFix();
    }

    right_side_bar() {
        this.right_sidebar = !this.right_sidebar
        this.rightSidebarEvent.emit(this.right_sidebar)
    }

    collapseSidebar() {
        this.navServices.collapseSidebar = !this.navServices.collapseSidebar
    }

    home() {
        this.commonService.clearData();
        this.router.navigate(["App/DxRoot"]);
    }

    openMobileNav() {
        this.openNav = !this.openNav;
    }

    public changeLanguage(lang) {
        this.translate.use(lang);

        if (lang === "ar")
            this.customize.setLayoutType("rtl")
        else
            this.customize.setLayoutType("ltr")
    }

    searchTerm(term: any) {
        term ? this.addFix() : this.removeFix();
        if (!term) return this.menuItems = [];
        let items = [];
        term = term.toLowerCase();
        this.items.filter(menuItems => {
            if (menuItems.title.toLowerCase().includes(term) && menuItems.type === 'link') {
                items.push(menuItems);
            }
            if (!menuItems.children) return false
            menuItems.children.filter(subItems => {
                if (subItems.title.toLowerCase().includes(term) && subItems.type === 'link') {
                    subItems.icon = menuItems.icon
                    items.push(subItems);
                }
                if (!subItems.children) return false
                subItems.children.filter(suSubItems => {
                    if (suSubItems.title.toLowerCase().includes(term)) {
                        suSubItems.icon = menuItems.icon
                        items.push(suSubItems);
                    }
                })
            })
            this.checkSearchResultEmpty(items)
            this.menuItems = items
        });
    }

    checkSearchResultEmpty(items) {
        if (!items.length)
            this.searchResultEmpty = true;
        else
            this.searchResultEmpty = false;
    }

    addFix() {
        this.searchResult = true;
        body.classList.add("offcanvas");
    }

    removeFix() {
        this.searchResult = false;
        body.classList.remove("offcanvas");
        this.text = "";
    }

    ngOnInit() {
        this.navServices.items.subscribe(menuItems => {
            this.items = menuItems
        });
    }

    logOff() {

        document.getElementById('logoutForm').click();
    }

    logout() {

        this.apiService.post('App/Account/Logout', {}).subscribe((res: any) => {
            this.commonService.clearData();
            this.authService.logout();
            this.translate.use(this.translate.defaultLang);
            if (this.translate.defaultLang == 'ar') {
                this.customize.setLayoutType('rtl')
            }
            else {
                this.customize.setLayoutType('ltr')
            }
            this.modalService.dismissAll();
        }, (reason) => {
            this.commonService.clearData();
            this.authService.logout();
            this.translate.use(this.translate.defaultLang);
            if (this.translate.defaultLang == 'ar') {
                this.customize.setLayoutType('rtl')
            }
            else {
                this.customize.setLayoutType('ltr')
            }
            this.modalService.dismissAll();
        });

        //document.getElementById('logoutForm').click();
        //this.router.navigate(['/login']);
    }

    missingTranslation() {
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(CommonService.missingTranslations);
        const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, 'Translate.xlsx');
    }

}
